import React, { Fragment } from 'react';
import cn from 'classnames';

import Header from 'components/Header';
import Footer from 'components/Footer';
import { Grid, Column } from 'components/Layout';

import CircleDeclined from 'assets/icons/circle-declined.svg';
import style from './style.scss';

const ManualVerification = () => (
  <Fragment>
    <Header />
    <section className={cn('grid-container fluid section', style['borrowers-apply'])}>
      <div className="grid-container fluid borrowers-message">
        <div className="grid-container">
          <Grid className="grid-margin-x max-limited">
            <Column className="small-12 large-10 large-offset-1">
              <img src={CircleDeclined} alt="circle declined" />
              <h2 className="text-center mt-3">Agreement Signature Pending</h2>
              <p className="text-center mb-4">Sorry, we were unable to confirm your identity. Call 800-994-6177 Ext 3 to continue signing the loan agreement.</p>
            </Column>
          </Grid>
        </div>
      </div>
    </section>
    <Footer />
  </Fragment>
);

export default ManualVerification;
